import React from 'react';

import {Icon} from '@stubhub/bamboo';

import Bullet from '../../../../components/icons/bullet/index';

// TODO: Consolidate All Icons into one file

const Icons = {
  mobile: <Icon name="MobileTicket" />,
  mobileTransfer: <Icon name="MobileTransfer" />,
  paper: <Icon name="PaperTickets" />,
  electronic: <Icon name="Print" />,
};

const getIcon = (key) => {
  let Icon = Icons[key];
  if (!Icon) {
    Icon = <Bullet />;
  }

  return Icon;
};

export default getIcon;
